/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetDbBackupsResponse } from '../models';
// @ts-ignore
import type { GetGlobalVarsResponse } from '../models';
// @ts-ignore
import type { GetPendingEntityCountResponse } from '../models';
// @ts-ignore
import type { GetUserMailBatchesResponse } from '../models';
// @ts-ignore
import type { GlobalVarFlag } from '../models';
// @ts-ignore
import type { RunUserMailsResponse } from '../models';
// @ts-ignore
import type { SendTestEmailBody } from '../models';
// @ts-ignore
import type { SendUserMailTestBody } from '../models';
// @ts-ignore
import type { SendUserMailTestResponse } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { UpdateGlobalVarBody } from '../models';
// @ts-ignore
import type { UserMailPreviewResponse } from '../models';
/**
 * ManagementApiApi - axios parameter creator
 */
export const ManagementApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiGetAdminGlobalVars: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/global-vars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiGetPendingEntitiesCounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/management_api/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiListS3Backups: async (category?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/list-s3-backups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiListUserMailBatches: async (days?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/user-mails/batches`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiPreviewUserMails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/user-mails/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiRunUserMails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/user-mails/run`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendTestEmailBody} sendTestEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiSendTestEmail: async (sendTestEmailBody: SendTestEmailBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendTestEmailBody' is not null or undefined
            assertParamExists('managementApiSendTestEmail', 'sendTestEmailBody', sendTestEmailBody)
            const localVarPath = `/admin/test-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendTestEmailBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SendUserMailTestBody} sendUserMailTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiSendUserMailTest: async (sendUserMailTestBody: SendUserMailTestBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sendUserMailTestBody' is not null or undefined
            assertParamExists('managementApiSendUserMailTest', 'sendUserMailTestBody', sendUserMailTestBody)
            const localVarPath = `/admin/user-mails/test`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(sendUserMailTestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {UpdateGlobalVarBody} updateGlobalVarBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiUpdateAdminGlobalVar: async (name: string, updateGlobalVarBody: UpdateGlobalVarBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('managementApiUpdateAdminGlobalVar', 'name', name)
            // verify required parameter 'updateGlobalVarBody' is not null or undefined
            assertParamExists('managementApiUpdateAdminGlobalVar', 'updateGlobalVarBody', updateGlobalVarBody)
            const localVarPath = `/admin/global-vars/{name}`
                .replace('{name}', encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateGlobalVarBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagementApiApi - functional programming interface
 */
export const ManagementApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ManagementApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementApiGetAdminGlobalVars(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGlobalVarsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementApiGetAdminGlobalVars(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApiApi.managementApiGetAdminGlobalVars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementApiGetPendingEntitiesCounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPendingEntityCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementApiGetPendingEntitiesCounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApiApi.managementApiGetPendingEntitiesCounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [category] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementApiListS3Backups(category?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDbBackupsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementApiListS3Backups(category, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApiApi.managementApiListS3Backups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementApiListUserMailBatches(days?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserMailBatchesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementApiListUserMailBatches(days, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApiApi.managementApiListUserMailBatches']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementApiPreviewUserMails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserMailPreviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementApiPreviewUserMails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApiApi.managementApiPreviewUserMails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementApiRunUserMails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunUserMailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementApiRunUserMails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApiApi.managementApiRunUserMails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendTestEmailBody} sendTestEmailBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementApiSendTestEmail(sendTestEmailBody: SendTestEmailBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementApiSendTestEmail(sendTestEmailBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApiApi.managementApiSendTestEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SendUserMailTestBody} sendUserMailTestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementApiSendUserMailTest(sendUserMailTestBody: SendUserMailTestBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendUserMailTestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementApiSendUserMailTest(sendUserMailTestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApiApi.managementApiSendUserMailTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {UpdateGlobalVarBody} updateGlobalVarBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async managementApiUpdateAdminGlobalVar(name: string, updateGlobalVarBody: UpdateGlobalVarBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GlobalVarFlag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.managementApiUpdateAdminGlobalVar(name, updateGlobalVarBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ManagementApiApi.managementApiUpdateAdminGlobalVar']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ManagementApiApi - factory interface
 */
export const ManagementApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ManagementApiApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiGetAdminGlobalVars(options?: RawAxiosRequestConfig): AxiosPromise<GetGlobalVarsResponse> {
            return localVarFp.managementApiGetAdminGlobalVars(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiGetPendingEntitiesCounts(options?: RawAxiosRequestConfig): AxiosPromise<GetPendingEntityCountResponse> {
            return localVarFp.managementApiGetPendingEntitiesCounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagementApiApiManagementApiListS3BackupsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiListS3Backups(requestParameters: ManagementApiApiManagementApiListS3BackupsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetDbBackupsResponse> {
            return localVarFp.managementApiListS3Backups(requestParameters.category, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagementApiApiManagementApiListUserMailBatchesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiListUserMailBatches(requestParameters: ManagementApiApiManagementApiListUserMailBatchesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetUserMailBatchesResponse> {
            return localVarFp.managementApiListUserMailBatches(requestParameters.days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiPreviewUserMails(options?: RawAxiosRequestConfig): AxiosPromise<UserMailPreviewResponse> {
            return localVarFp.managementApiPreviewUserMails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiRunUserMails(options?: RawAxiosRequestConfig): AxiosPromise<RunUserMailsResponse> {
            return localVarFp.managementApiRunUserMails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagementApiApiManagementApiSendTestEmailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiSendTestEmail(requestParameters: ManagementApiApiManagementApiSendTestEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.managementApiSendTestEmail(requestParameters.sendTestEmailBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagementApiApiManagementApiSendUserMailTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiSendUserMailTest(requestParameters: ManagementApiApiManagementApiSendUserMailTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<SendUserMailTestResponse> {
            return localVarFp.managementApiSendUserMailTest(requestParameters.sendUserMailTestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ManagementApiApiManagementApiUpdateAdminGlobalVarRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managementApiUpdateAdminGlobalVar(requestParameters: ManagementApiApiManagementApiUpdateAdminGlobalVarRequest, options?: RawAxiosRequestConfig): AxiosPromise<GlobalVarFlag> {
            return localVarFp.managementApiUpdateAdminGlobalVar(requestParameters.name, requestParameters.updateGlobalVarBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for managementApiListS3Backups operation in ManagementApiApi.
 */
export interface ManagementApiApiManagementApiListS3BackupsRequest {
    readonly category?: string | null
}

/**
 * Request parameters for managementApiListUserMailBatches operation in ManagementApiApi.
 */
export interface ManagementApiApiManagementApiListUserMailBatchesRequest {
    readonly days?: number
}

/**
 * Request parameters for managementApiSendTestEmail operation in ManagementApiApi.
 */
export interface ManagementApiApiManagementApiSendTestEmailRequest {
    readonly sendTestEmailBody: SendTestEmailBody
}

/**
 * Request parameters for managementApiSendUserMailTest operation in ManagementApiApi.
 */
export interface ManagementApiApiManagementApiSendUserMailTestRequest {
    readonly sendUserMailTestBody: SendUserMailTestBody
}

/**
 * Request parameters for managementApiUpdateAdminGlobalVar operation in ManagementApiApi.
 */
export interface ManagementApiApiManagementApiUpdateAdminGlobalVarRequest {
    readonly name: string

    readonly updateGlobalVarBody: UpdateGlobalVarBody
}

/**
 * ManagementApiApi - object-oriented interface
 */
export class ManagementApiApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managementApiGetAdminGlobalVars(options?: RawAxiosRequestConfig) {
        return ManagementApiApiFp(this.configuration).managementApiGetAdminGlobalVars(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managementApiGetPendingEntitiesCounts(options?: RawAxiosRequestConfig) {
        return ManagementApiApiFp(this.configuration).managementApiGetPendingEntitiesCounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagementApiApiManagementApiListS3BackupsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managementApiListS3Backups(requestParameters: ManagementApiApiManagementApiListS3BackupsRequest = {}, options?: RawAxiosRequestConfig) {
        return ManagementApiApiFp(this.configuration).managementApiListS3Backups(requestParameters.category, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagementApiApiManagementApiListUserMailBatchesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managementApiListUserMailBatches(requestParameters: ManagementApiApiManagementApiListUserMailBatchesRequest = {}, options?: RawAxiosRequestConfig) {
        return ManagementApiApiFp(this.configuration).managementApiListUserMailBatches(requestParameters.days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managementApiPreviewUserMails(options?: RawAxiosRequestConfig) {
        return ManagementApiApiFp(this.configuration).managementApiPreviewUserMails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managementApiRunUserMails(options?: RawAxiosRequestConfig) {
        return ManagementApiApiFp(this.configuration).managementApiRunUserMails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagementApiApiManagementApiSendTestEmailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managementApiSendTestEmail(requestParameters: ManagementApiApiManagementApiSendTestEmailRequest, options?: RawAxiosRequestConfig) {
        return ManagementApiApiFp(this.configuration).managementApiSendTestEmail(requestParameters.sendTestEmailBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagementApiApiManagementApiSendUserMailTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managementApiSendUserMailTest(requestParameters: ManagementApiApiManagementApiSendUserMailTestRequest, options?: RawAxiosRequestConfig) {
        return ManagementApiApiFp(this.configuration).managementApiSendUserMailTest(requestParameters.sendUserMailTestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ManagementApiApiManagementApiUpdateAdminGlobalVarRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public managementApiUpdateAdminGlobalVar(requestParameters: ManagementApiApiManagementApiUpdateAdminGlobalVarRequest, options?: RawAxiosRequestConfig) {
        return ManagementApiApiFp(this.configuration).managementApiUpdateAdminGlobalVar(requestParameters.name, requestParameters.updateGlobalVarBody, options).then((request) => request(this.axios, this.basePath));
    }
}

